import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Shield, Mail, BarChart, Settings, CalendarX } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <Clock className="w-6 h-6 text-brand-accent" data-id="element-32" />,
    title: '24/7 erreichbar',
    description: 'Auch nachts, am Wochenende und im Urlaub.'
  }, {
    icon: <Shield className="w-6 h-6 text-brand-accent" data-id="element-33" />,
    title: 'DSGVO-konform',
    description: 'Serverstandort Deutschland/EU. Ihre Daten bleiben sicher.'
  }, {
    icon: <Mail className="w-6 h-6 text-brand-accent" data-id="element-34" />,
    title: 'E-Mail nach jedem Anruf',
    description: 'Automatische Benachrichtigung mit allen Details.'
  }, {
    icon: <BarChart className="w-6 h-6 text-brand-accent" data-id="element-35" />,
    title: 'Gesprächsdauer erfasst',
    description: 'Transparent und abrechenbar — minutengenau.'
  }, {
    icon: <Settings className="w-6 h-6 text-brand-accent" data-id="element-36" />,
    title: 'Keine IT-Kenntnisse nötig',
    description: 'Vollständig eingerichtet geliefert. Plug & Play.'
  }, {
    icon: <CalendarX className="w-6 h-6 text-brand-accent" data-id="element-37" />,
    title: 'Monatlich kündbar',
    description: 'Keine langen Vertragslaufzeiten. Flexibel bleiben.'
  }];
  return <section className="py-20 bg-white" data-id="element-38">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="text-center mb-16" data-id="element-40">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-41">
            Alles, was Sie brauchen. Nichts, was Sie nicht brauchen.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-42">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-6 rounded-2xl hover:bg-brand-gray transition-colors duration-300" data-id="element-43">
              <div className="flex-shrink-0 w-12 h-12 bg-brand-light rounded-xl flex items-center justify-center mr-4" data-id="element-44">
                {feature.icon}
              </div>
              <div data-id="element-45">
                <h3 className="text-lg font-bold text-brand-dark mb-2" data-id="element-46">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-47">{feature.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}